<template>
  <div class="p-3 safety-contacts-wrapper">
    <b-container>
      <section id="header">
        <div class="mt-2 mb-4">
          <p class="text-center h4">
            Clinical Trial Safety Reporting Contact Information
          </p>
        </div>
      </section>
      <hr class="my-4" />

      <section class="mb-4" v-if="!loading">
        <multiselect
          v-model="selected"
          :allow-empty="true"
          :disabled="loading"
          :options="filteredOptions"
          :searchable="true"
          :internal-search="false"
          @search-change="customSearch"
          class="multiselect-dropdown"
          label="country_name"
          placeholder="Select a country"
          track-by="country_name"
        ></multiselect>

        <b-card class="mt-4" v-if="selected">
          <b-row class="mb-3 text-center">
            <b-col md="4" class="mb-3">
              <strong>Email:</strong>
              <p>
                <a :href="'mailto:' + selected.adverse_event_contact_email">
                  {{ selected.adverse_event_contact_email }}
                </a>
              </p>
            </b-col>
            <b-col md="4" class="mb-3">
              <strong>Fax Numbers:</strong>
              <p style="white-space: pre-line">{{ selected.fax_numbers }}</p>
            </b-col>
            <b-col md="4" class="mb-3">
              <strong>Phone Details:</strong>
              <div v-html="formatPhoneNumbers(selected.phone_additional_details)"></div>
            </b-col>
          </b-row>
        </b-card>
      </section>

      <div class="text-center">
        <b-spinner v-if="loading" type="grow"></b-spinner>
      </div>
    </b-container>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: 'SafetyContacts',

    data() {
      return {
        selected: null,
        loading: false,
        units: [],
        filteredOptions: [],
      };
    },

    async created() {
      await this.fetchUnits();
    },

    methods: {
      customSearch(input) {
        if (input) {
          this.filteredOptions = this.units.filter(unit =>
            unit.country_name.toLowerCase().startsWith(input.toLowerCase()),
          );
        } else {
          this.filteredOptions = this.units;
        }
      },

      async fetchUnits() {
        this.loading = true;
        try {
          const response = await axios.get('/api/safety-contacts');
          this.units = response.data;
          this.filteredOptions = this.units;
        } catch (error) {
          this.$bvToast.toast('Error loading safety contacts', {
            title: 'Error',
            variant: 'danger',
          });
        } finally {
          this.loading = false;
        }
      },

      formatPhoneNumbers(text) {
        if (!text) return '';

        // First, let's ensure consistent line breaks before Tel/Cell prefixes
        let formattedText = text.replace(/(\s*)(Tel\.|Cell:)/g, '\n$2');

        // Remove any potential empty lines at the start
        formattedText = formattedText.trim();

        // Regular expression to match phone numbers in various formats
        const phoneRegex = /(\+?\d[\d\s-]{8,})/g;

        // Replace phone numbers with clickable links while preserving labels and descriptions
        return formattedText
          .split('\n')
          .map(line => {
            return line.replace(phoneRegex, match => {
              const cleanNumber = match.replace(/[\s-]/g, '');
              return `<a href="tel:${cleanNumber}" class="text-primary">${match}</a>`;
            });
          })
          .join('\n');
      },
    },
  };
</script>

<style scoped>
  .safety-contacts-wrapper {
    min-height: 600px; /* Adjust this value based on your needs */
    background-color: white;
  }

  .multiselect-dropdown {
    z-index: 1000;
    position: relative; /* Add this */
  }

  /* Ensure the dropdown appears above other elements */
  .multiselect__content-wrapper {
    z-index: 1001; /* Higher than parent */
  }

  /* Add space between card elements */
  .card p:last-child {
    margin-bottom: 0;
  }
</style>
